import _find from "lodash/find";
import React from 'react';
import { useStaticQuery } from 'gatsby';
import { VStack, Heading, Box, Button } from '@chakra-ui/react';
import PhoneNumber from '@interness/web-core/src/components/text/PhoneNumber/PhoneNumber';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import Mounted from '@interness/web-core/src/components/structure/Mounted/Mounted';
import OpeningPeriods from './OpeningPeriods';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ContactSidebarContent = () => {
  const data = useStaticQuery(query);
  const {
    emails,
    numbers,
    addresses,
    display_name
  } = data.directusCompany;
  const email = _find(emails, email => email.primary).email;
  const phoneNumber = _find(numbers, number => number.type === 'phone' && number.primary);
  const address = encodeURIComponent(`${addresses[0].street}+${addresses[0].number}+${addresses[0].zip_code}+${addresses[0].city}`);
  return ___EmotionJSX(VStack, null, ___EmotionJSX(Box, {
    w: "90%"
  }, ___EmotionJSX(Heading, {
    as: "h4",
    size: "md",
    mb: 4,
    mt: 6
  }, display_name), ___EmotionJSX(Box, {
    w: "100%",
    p: 4
  }, ___EmotionJSX(Heading, {
    as: "h5",
    size: "sm",
    mb: 4
  }, "Kontakt"), ___EmotionJSX("address", null, ___EmotionJSX("p", null, addresses[0].street, " ", addresses[0].number, " ", ___EmotionJSX("br", null), addresses[0].zip_code, " ", addresses[0].city)), ___EmotionJSX("p", null, ___EmotionJSX(Link, {
    to: `https://www.google.com/maps/dir/?api=1&destination=${address}`,
    external: true
  }, "Mit Google Maps navigieren")), ___EmotionJSX("p", null, ___EmotionJSX(Link, {
    to: `mailto:${email}`,
    external: true
  }, email), " ", ___EmotionJSX("br", null), ___EmotionJSX(PhoneNumber, {
    number: phoneNumber.number
  }))), data.site.siteMetadata.hasCalCom && ___EmotionJSX(Box, {
    w: "100%",
    p: 4
  }, ___EmotionJSX(Button, {
    colorScheme: "brand",
    sx: {
      textDecoration: 'none'
    },
    as: Link,
    to: "/terminvereinbarung",
    w: "100%"
  }, "Zur Terminvereinbarung")), ___EmotionJSX(Box, {
    w: "100%",
    p: 4,
    borderBottom: "1px solid #e8e8e8"
  }, ___EmotionJSX(Mounted, null, ___EmotionJSX(OpeningPeriods, {
    openingPeriods: data.allDirectusOpeningPeriods.nodes
  })))), data.allDirectusBranches.nodes.map(branch => {
    const branchAddress = encodeURIComponent(`${branch.street}+${branch.zip}+${branch.city}`);
    return ___EmotionJSX(Box, {
      w: "90%"
    }, ___EmotionJSX(Heading, {
      as: "h4",
      size: "md",
      mb: 4,
      mt: 6
    }, branch.display_name), ___EmotionJSX(Box, {
      w: "100%",
      p: 4
    }, ___EmotionJSX(Heading, {
      as: "h5",
      size: "sm",
      mb: 4
    }, "Kontakt"), ___EmotionJSX("address", null, ___EmotionJSX("p", null, branch.street, ___EmotionJSX("br", null), branch.zip, " ", branch.city)), ___EmotionJSX("p", null, ___EmotionJSX(Link, {
      to: `https://www.google.com/maps/dir/?api=1&destination=${branchAddress}`,
      external: true
    }, "Mit Google Maps Navigieren")), ___EmotionJSX("p", null, ___EmotionJSX(Link, {
      to: `mailto:${email}`,
      external: true
    }, email), " ", ___EmotionJSX("br", null), ___EmotionJSX(PhoneNumber, {
      number: branch.phone
    }))), ___EmotionJSX(Box, {
      w: "100%",
      p: 4,
      borderBottom: "1px solid #e8e8e8"
    }, ___EmotionJSX(OpeningPeriods, {
      openingPeriods: branch.opening_periods
    })));
  }));
};
const query = "1846512627";
export default ContactSidebarContent;